//import styles from './OrderEngineComment.module.css'
import styles from '../CommonCss/OrderEngineCommon.module.css'

import React, {useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import WaitLoader from "../../../WaitLoader/WaitLoader";

interface OrderEngineAdminCommentPropsInt
{
    orderId:string
    onClose: ()=>void
    textComment:string
    onSuccess?: ()=>void
}
interface UpdateOrderInt
{
    orderId:string
    id?:number
    fieldList: string[]
    valList: any[]
    mode:number
}

export default function OrderEngineAdminComment({orderId,onSuccess,onClose,textComment}:OrderEngineAdminCommentPropsInt){
    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/update/field","post",orderUpdateData);
    const [comment, setComment] = useState(textComment ? textComment : "")

    const updateComment = useRef<ErrorLineItemRef>(null)

    const handleUpdateComment = (clear:boolean = false)=>{
        orderUpdateData.current = {
            orderId: orderId,
            mode:3,

            fieldList: ["adminNote"],
            valList:[clear ? "" : comment.trim()]
        }
        exOrderUpdate().then((e)=>{
            if(e?.success)
            {
                if(updateComment.current)updateComment.current.show(`SIM в заказа ${orderId} обновлена`,false,0)
                if(onSuccess) onSuccess()
                return
            }
            if(updateComment.current)updateComment.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        }).catch((e)=>{
            if(updateComment.current)updateComment.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })


    }

    return(
        <ModalWindow>
            <MainFormTemplate title={`Комментарий администратора`} maxWidth={"800px"} background={"white"}>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={comment}
                            mode={"ie"}
                            inputType={2}
                            lineCount={5}
                            info={"Комментарий по заказу"}
                            title={"Текст"}
                            titleShift={-2}
                            onChange={(e)=>{
                                setComment(e?.trim())
                            }}
                        ></InputItem>
                    </div>
                </div>
                <ErrorLineItem ref={updateComment} ></ErrorLineItem>
                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!comment?.length}
                                onClick={(e)=>{
                                    handleUpdateComment()
                                }}
                        >Обновить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={comment?.length === 0}
                                onClick={(e)=>{

                                    handleUpdateComment(true)
                                    setComment("")
                                }}
                        >Очистить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderUpdate } api={rsOrderUpdate} onlyLoading={true}>

                    </WaitLoader>

                </div>



            </MainFormTemplate>
        </ModalWindow>
    )
}